import axios from 'axios';
import serialize from 'form-serialize';

const contactForm = document.querySelector('#contactForm'),
  apiContactUrl = process.env.CRT_MAESTRO_API_BASE_EXTERNAL_URL + '/contact-form-endpoint',
  frontUrl = process.env.CRT_FRONT_URL;

contactForm.addEventListener('submit', (e) => {
  e.preventDefault();

  const serializedFormValues = serialize(contactForm, { hash: true, });

  axios.post(apiContactUrl, serializedFormValues, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(function (response) {
    if (200 === response.status) {
      window.location.replace(frontUrl + contactData.confirmationOkPage);
    } else {
      window.location.replace(frontUrl + contactData.confirmationKoPage);
    }
  })
  .catch(function (error) {
    console.log(error);
  });

}, false);
